import React, { useState } from "react";

const UploadResumes = ({ roles, onUpload }) => {
  const [selectedRole, setSelectedRole] = useState("");
  const [files, setFiles] = useState([]);

  return (
    <div className="flex justify-center w-full p-10">
      <div className="w-full max-w-2xl bg-white rounded-xl shadow-md p-8 border border-gray-200">
        <h2 className="text-2xl font-semibold text-gray-900 mb-4">Upload Resumes</h2>

        <label className="text-gray-700 font-medium block mb-2">Select Role</label>
        <select
          className="w-full border border-gray-300 rounded-lg p-3 mb-6"
          value={selectedRole}
          onChange={(e) => setSelectedRole(e.target.value)}
        >
          <option value="">Choose Role</option>
          {roles.map((r) => (
            <option key={r} value={r.replace("/", "")}>
              {r.replace("/", "")}
            </option>
          ))}
        </select>

        <label className="text-gray-700 font-medium block mb-2">Upload Resumes</label>
        <input
          type="file"
          multiple
          className="w-full border border-gray-300 rounded-lg p-3"
          onChange={(e) => setFiles(Array.from(e.target.files))}
        />

        <button
          disabled={!selectedRole || files.length === 0}
          onClick={() => onUpload(selectedRole, files)}
          className="mt-6 w-full bg-orange-600 text-white py-3 rounded-lg hover:bg-orange-700 disabled:bg-gray-300"
        >
          Upload
        </button>
      </div>
    </div>
  );
};

export default UploadResumes;
